// extracted by mini-css-extract-plugin
export default {"container":"PaymentPage_container__yFDwO"};